<template>
  <div>
    <div v-if="this.loading">
      Loading.....
    </div>
    <div v-else-if="this.errormessage">
      <oops :errormsg="errormessage" />
    </div>
    <tabs
      v-else-if="!this.loading && !this.errormessage"
      class="d-none d-md-block"
      pills
      type="primary"
      icons
      centered
      value="position"
    >
      <tab-pane
        id="budget"
        key="budget"
      >
        <span slot="title">
          <div class="row align-items-center">
            <div class="content-heading">Budget</div>
          </div>
        </span>
        <budget />
      </tab-pane>
      <tab-pane
        id="receipts"
        key="receipts"
      >
        <span slot="title">
          <div class="row align-items-center">
            <div class="content-heading">Receipts</div>
          </div>
        </span>
        <receipts />
      </tab-pane>
      <tab-pane
        id="wff"
        key="wff"
      >
        <span slot="title">
          <div class="row align-items-center">
            <div class="content-heading">World Friendship Fund</div>
          </div>
        </span>
        <world-friendship-fund />
      </tab-pane>
    </tabs>
    <div class="d-block d-md-none col-12 form-group">
      <fg-input>
        <label class="control-label mobileLabel">Select Finance Section</label>
        <el-select
          class="select-default2"
          size="large"
          name="goalSelector"
          placeholder=""
          v-model="mobileComponent"
        >
          <el-option
            class="select-default2"
            value="Budget"
            label="Budget"
            key="Budget"
          />
          <el-option
            class="select-default2"
            value="Receipts"
            label="Receipts"
            key="Receipts"
          />
          <el-option
            class="select-default2"
            value="World Friendship Fund"
            label="World Friendship Fund"
            key="World Friendship Fund"
          />
        </el-select>
      </fg-input>
      <budget
        class="d-block d-md-none"
        v-if="mobileComponent === 'Budget'"
      />
      <receipts
        class="d-block d-md-none"
        v-if="mobileComponent === 'Receipts'"
      />
      <world-friendship-fund
        class="d-block d-md-none"
        v-if="mobileComponent === 'World Friendship Fund'"
      />
    </div>
  </div>
</template>

<script>
import oops from '@/components/_main/oops.vue'
import Tabs from '@/plugins/paper-components/tabs/tabs.vue'
import TabPane from '@/plugins/paper-components/tabs/tab.vue'
import Budget from '@/components/finance/budget.vue'
import Receipts from '@/components/finance/receipts.vue'
import WorldFriendshipFund from '@/components/finance/world-friendship-fund.vue'

export default {
  name: 'Finances',
  components: {
    oops,
    Tabs,
    TabPane,
    Budget,
    Receipts,
    WorldFriendshipFund
  },
  data: function () {
    return {
      loading: false,
      errormessage: null,
      mobileComponent: 'Budget'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.mobileLabel {
  font-size: 0.8571em;
  margin-bottom: 5px;
  color: #9A9A9A;
}
</style>
